// The two link types in jira_linked_issue that express duplication. The same link is
// mirrored from both ends via the `direction` column, so either value can legitimately
// appear on a ticket that has been linked.
export const DUP_LINK_TYPES = ['duplicates', 'is duplicated by'];

// Status shown in the "Link check" column, computed server-side by
// DuplicatesService.linkState and returned on each row as `linkState`:
//   ok          — resolved as Duplicate and a duplicate link exists
//   missing     — resolved as Duplicate but nothing links it (the gap this tool exists to find)
//   linked-only — linked as a duplicate but not resolved as one
//   none        — neither; nothing to check
export const LINK_CHECK_LABELS = {
  ok: 'Linked',
  missing: 'Not linked',
  'linked-only': 'Link, no resolution',
  none: '—',
};
